import { React } from "react";
import { useState } from "react";
import {
  Text,
  Flex,
  Button,
  IconButton,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import styles from "./Comparison.module.css";

export default function Comparison() {
  return (
    <Flex className={styles.compareSection}>
      <Grid
        templateColumns={{
          base: "1fr 0.6fr 1fr",
          md: "1fr 1fr 1fr",
        }}
        gap={6}
        width="100%"
      >
        <GridItem w="100%">
          <Text className={styles.compareTitleText}>Kuria Bar</Text>
        </GridItem>
        <GridItem w="100%">
          <Text className={styles.compareTitleText}>vs</Text>
        </GridItem>
        <GridItem w="100%">
          <Text className={styles.compareTitleText}>Steel</Text>
        </GridItem>
      </Grid>
      <div className={styles.scrollContainer}>
        <div className={styles.scrollContent}>
          <Grid gridAutoRows="1fr" gap={2} alignItems="stretch">
            <GridItem className={styles.comparisonGrid}>
              <ComparisonBar />
            </GridItem>
            <GridItem
              className={styles.comparisonGrid}
              display="flex"
              marginTop={"-8px"}
            >
              <ComparisonBox
                kuriaText="Tahan terhadap korosi dan bahan kimia"
                title="KOROSI"
                besiText="Rentan terhadap karat dan korosi, terutama di lingkungan yang mengandung garam"
              />
            </GridItem>
            <GridItem className={styles.comparisonGrid}>
              <ComparisonBox
                kuriaText="1/4 bobot besi sehingga biaya transportasi rendah dan peningkatan efisiensi kerja"
                title="BERAT"
                besiText="Berat unit tinggi sehingga biaya transportasi mahal"
              />
            </GridItem>
            <GridItem className={styles.comparisonGrid}>
              <ComparisonBox
                kuriaText="Kekuatan tarik sekitar 3x lebih kuat dari tulangan baja"
                title="DAYA TARIK"
                besiText="Kekuatan tarik rendah dibandingkan dengan material lain"
              />
            </GridItem>
            <GridItem className={styles.comparisonGrid}>
              <ComparisonBox
                kuriaText="Biaya lebih rendah daripada tulangan baja"
                title="BIAYA"
                besiText="Harga tulangan baja dapat fluktuasi dan naik"
              />
            </GridItem>
            <GridItem className={styles.comparisonGrid}>
              <ComparisonBox
                kuriaText="Tidak menghantarkan panas dan listrik"
                title="KONDUKSI"
                besiText="Konduktvitas panas tinggi"
              />
            </GridItem>
          </Grid>
        </div>
      </div>
      <Text className={styles.slideText}>slide {">>>"}</Text>
    </Flex>
  );
}

function ComparisonBar() {
  return (
    <Grid
      templateColumns={{
        base: "1fr 0.6fr 1fr",
        md: "1fr 1fr 1fr",
      }}
      gap={6}
      width="100%"
    >
      <GridItem w="100%" colSpan={1} display="flex" alignItems="flex-end">
        <img
          src="/assets/kuriabar/comparison-black.png"
          alt="Kuria Bar Hitam"
          style={{ zIndex: 2 }}
          width="100%"
        />
      </GridItem>
      <GridItem w="100%" colSpan={1} />
      <GridItem w="100%" colSpan={1} display="flex" alignItems="flex-end">
        <img
          src="/assets/kuriabar/comparison-grey.png"
          alt="Besi Beton"
          style={{ zIndex: 2 }}
          width="100%"
        />
      </GridItem>
    </Grid>
  );
}

function ComparisonBox({ kuriaText, title, besiText }) {
  return (
    <Grid
      templateColumns={{
        base: "1fr 0.6fr 1fr",
        md: "1fr 1fr 1fr",
      }}
      gap={6}
      width="100%"
    >
      <GridItem w="100%" colSpan={1}>
        <Flex className={styles.comparisonBox}>
          <Text className={styles.comparisonText}>{kuriaText}</Text>
        </Flex>
      </GridItem>
      <GridItem
        width="100%"
        colSpan={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text className={styles.comparisonHeading}>{title}</Text>
      </GridItem>
      <GridItem w="100%" colSpan={1}>
        <Flex className={styles.comparisonBox}>
          <Text className={styles.comparisonText}>{besiText}</Text>
        </Flex>
      </GridItem>
    </Grid>
  );
}
